import { PanelPortal, PanelContent } from '@frontend/panel-engine';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { TaskList, TaskModeRenderer } from './components';
import { TASK_CENTER_CONSTANTS } from './constants';

export const TaskCenterPanel = () => {
  const { isTaskCenterOpen, setIsTaskCenterOpen } = useTaskCenterStore(['isTaskCenterOpen', 'setIsTaskCenterOpen']);

  const onClose = () => {
    setIsTaskCenterOpen(false);
  };

  if (isTaskCenterOpen) {
    return (
      <PanelPortal enableAnimations id='task-center' width={TASK_CENTER_CONSTANTS.PANEL_WIDTH} onClose={onClose}>
        <PanelContent padding={false} css={{ display: 'flex' }}>
          <TaskList />
          <TaskModeRenderer />
        </PanelContent>
      </PanelPortal>
    );
  }
  return null;
};
